<template>
  <footer class="footer" :class="{ 'is-copyonly': !menu, 'bg-gray': isCustomFooter }">
    <div class="footer-menu" v-if="menu && route.params.directory && !eventList">
      <!-- <router-link v-if="isCustomFooter" class="btn btn-bd-main footer-inquiry" :to="{ name: contactRoute }">お問合せはこちら</router-link> -->
      <nav class="footer-nav">
        <ul class="footer-nav-set">
          <li v-for="(item, index) in footerData" :key="index" class="footer-nav-item">
            <a v-if="item.href" class="footer-nav-link" :href="item.href" target="_blank">{{ item.label }}</a>
            <router-link v-else-if="item.routeName" class="footer-nav-link" :to="{ name: item.routeName }">{{ item.label }}</router-link>
          </li>
          <!-- li class="footer-nav-item"><router-link class="footer-nav-link" to="">ヘルプ</router-link></li -->
        </ul>
      </nav>
    </div>
    <p class="footer-copy" :class="{ 'custom-footer-copy': !(menu && route.params.directory && !eventList) }">&copy;GMO DIGITAL Lab K.K. All Rights Reserved.</p>
  </footer>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

defineProps({
  menu: { type: Boolean, default: true },
  eventList: { type: Boolean, default: false },
  isCustomFooter: { type: Boolean, default: false },
});

const store = useStore();
const route = useRoute();

const eventInfo = computed(() => store.getters['event/childEventInfo'] || {});
const footerData = computed(() => [
  { href: eventInfo.value?.termsUrl, label: '利用規約' },
  { href: eventInfo.value?.lawUrl, label: '特定商取引法に基づく表記' },
  { href: eventInfo.value?.privacyPolicyUrl, label: 'プライバシーポリシー' },
  { href: eventInfo.value?.additionalUrl, label: eventInfo.value?.titleAdditionalUrl },
  // { href: eventInfo.value?..privacyPolicyUrl, label: 'ヘルプ' },
]);
</script>

<style scoped>
.custom-footer-copy {
  padding: 30px 0 20px;
}
</style>
